import { render, staticRenderFns } from "./orderdatetime.vue?vue&type=template&id=6c0187a4&"
import script from "./orderdatetime.vue?vue&type=script&lang=js&"
export * from "./orderdatetime.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports